import { makeRolls } from './seededRolls';

/**
 * Fixed seed for `SpaceBackdrop`'s star layer (issue #182). The dots must
 * look the same on every mount of the same variant — a seed keeps
 * `makeRolls`'s mulberry32 sequence reproducible instead of reshuffling on
 * every render.
 */
export const STAR_FIELD_SEED = 8817;

/**
 * Builds a single `box-shadow` value placing `count` 1px dots across the
 * viewport (percentage-based so they scale with it) at varying opacity —
 * cheap, static "stars" with no canvas and no rAF loop. `seed` (defaulting
 * to `STAR_FIELD_SEED`) is forwarded to `makeRolls` so the field is
 * deterministic; pass a different one only to get a visibly different field.
 */
export function generateStarFieldBoxShadow(count: number, seed: number = STAR_FIELD_SEED): string {
    const rolls = makeRolls(count * 3, seed);
    const shadows: string[] = [];
    for (let i = 0; i < count; i++) {
        const x = ((rolls[i * 3] ?? 0) * 100).toFixed(2);
        const y = ((rolls[i * 3 + 1] ?? 0) * 100).toFixed(2);
        const opacity = (0.35 + (rolls[i * 3 + 2] ?? 0) * 0.65).toFixed(2);
        shadows.push(`${x}vw ${y}vh 0 rgba(230,232,245,${opacity})`);
    }
    return shadows.join(', ');
}
